import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { ComponentsModule } from '@app/components/components.module';
import { APP_SWIPER_CONFIG_TOKEN } from '@app/components/pr-swiper/pr-swiper.module';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperOptions } from 'swiper';
import { EaGroupModule } from '../ea-group/ea-group.module';
import { EaGridkyActionsComponent } from './ea-gridky-actions/ea-gridky-actions.component';
import { EaGridkyCriteriaComponent } from './ea-gridky-criteria/ea-gridky-criteria.component';
import { EaGridkyDetailsComponent } from './ea-gridky-details/ea-gridky-details.component';
import { EaGridkyHeaderComponent } from './ea-gridky-header/ea-gridky-header.component';
import { EaGridkyInfoComponent } from './ea-gridky-info/ea-gridky-info.component';
import { EaGridkyPerformancesComponent } from './ea-gridky-performances/ea-gridky-performances.component';
import { EaGridkyPhotoComponent } from './ea-gridky-photo/ea-gridky-photo.component';
import { EaGridkySubtitleComponent } from './ea-gridky-subtitle/ea-gridky-subtitle.component';
import { EaGridkyComponent } from './ea-gridky.component';
import { EaGridkyService } from './ea-gridky.service';

const DEFAULT_SWIPER_CONFIG: SwiperOptions = {
  /* observer: true,
  direction: 'horizontal',
  touchStartPreventDefault: false,
  centeredSlides: false,
  spaceBetween: 20,
  slidesPerView: 1.3,
  slidesOffsetBefore: 1,
  slidesOffsetAfter: 1,
  threshold: 1,
  height: 200 */
};

@NgModule({
  declarations: [
    EaGridkyComponent,
    EaGridkyActionsComponent,
    EaGridkyPhotoComponent,
    EaGridkyCriteriaComponent,
    EaGridkyPerformancesComponent,
    EaGridkyDetailsComponent,
    EaGridkyInfoComponent,
    EaGridkyHeaderComponent,
    EaGridkySubtitleComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    EaGroupModule,
    TranslateModule,
    GoogleMapsModule,
  ],
  exports: [EaGridkyComponent],
  providers: [
    EaGridkyService,
    {
      provide: APP_SWIPER_CONFIG_TOKEN,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class EaGridkyModule {}
